import GeneralService from "./GeneralService";
import { Component } from "react";

export class CompanyService extends Component {
  public static getCompany(loadingHandler: any, apiKey: string) {
    return GeneralService.get(
      "/company/",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getAffiliatedCompanies(loadingHandler: any, apiKey: string) {
    return GeneralService.get(
      "/company/affiliated",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getAllCompanies(loadingHandler: any, apiKey: string) {
    return GeneralService.get(
      "/company/all",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getApplicationsByCompany(
    companyId: number | string,
    loadingHandler: any,
    apiKey: string,
  ) {
    return GeneralService.get(
      `/company/${companyId}/applications`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }

  public static getIntentGroupsByCompany(
    companyId: number | string,
    loadingHandler: any,
    apiKey: string,
  ) {
    return GeneralService.get(
      `/company/${companyId}/intent_groups`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey,
    );
  }
}
